module.exports = (__webpack_require__(0))(252);


//////////////////
// WEBPACK FOOTER
// delegated ./src/index.js from dll-reference girder_lib
// module id = 7
// module chunks = 0